// Sprint ONBOARD ONB.C3 (A.5, #831) — OAuth pop-up bounce relay.
//
// Mounted at /setup/oauth-bounce. The Drive OAuth callback redirects the pop-up
// window here with ?status=success|cancelled|admin_policy_enforced|error. This
// page is a DUMB relay: it forwards the status to the opener via postMessage
// (origin-scoped) and closes itself. It performs NO side effect based on the
// status value — the parent's message handler does origin + kind validation.
// If opened outside a pop-up (no window.opener), it renders a close-me fallback
// and posts nothing.

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const OAUTH_RESULT_KIND = 'gdrive-oauth-result';

export default function OAuthPopupBouncePage() {
  const [params] = useSearchParams();
  const status = params.get('status');
  const hasOpener = typeof window !== 'undefined' && !!window.opener;

  useEffect(() => {
    if (!hasOpener) return;
    try {
      window.opener.postMessage(
        { kind: OAUTH_RESULT_KIND, status },
        window.location.origin,   // targetOrigin scoping — never '*'
      );
    } finally {
      window.close();
    }
  }, [status, hasOpener]);

  return (
    <div
      data-testid="oauth-bounce"
      style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '48px 24px', background: 'var(--bg)', fontFamily: 'var(--font-body)',
        fontSize: 14, color: 'var(--text-secondary)',
      }}
    >
      {hasOpener
        ? 'Completing authorisation…'
        : 'You can close this window and return to BluePrint.'}
    </div>
  );
}
